<template>
  <div class="social-icons" :class="{ 'social-icons_large': large }">
    <a
      v-for="item in items"
      :key="item.type"
      :href="item.url"
      target="_blank"
      rel="noopener noreferrer"
      class="social-icons__link"
      :aria-label="item.label"
    >
      <span class="social-icons__icon" v-html="iconSvg(item.type)"></span>
    </a>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

const ICONS = {
  telegram: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>`,
  instagram: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a3.998 3.998 0 100 8 3.998 3.998 0 000-8zm0 6.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm5.5-6.5a.9.9 0 100 1.8.9.9 0 000-1.8zm-11 0a.9.9 0 100 1.8.9.9 0 000-1.8z"/></svg>`,
  tiktok: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1.05-.08 6.33 6.33 0 00-6.33 6.33 6.33 6.33 0 0010.86 4.5v-6.5a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/></svg>`
}

export default {
  name: 'SocialIcons',
  props: {
    /** Крупный вариант (для футера/блоков) */
    large: { type: Boolean, default: false }
  },
  setup() {
    const store = useStore()

    const items = computed(() => store.getters['contacts/items'])

    function iconSvg(type) {
      return ICONS[type] || ''
    }

    onMounted(() => {
      if (!items.value.length) store.dispatch('contacts/fetchContacts')
    })

    return { items, iconSvg }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.social-icons {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.social-icons__link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: inherit;
  opacity: 0.85;
  border-radius: 50%;
  transition: opacity 0.2s, transform 0.2s, color 0.2s;

  &:hover {
    opacity: 1;
    color: $color-accent-teal;
    transform: scale(1.08);
  }
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}

.social-icons__icon {
  display: block;
  width: 22px;
  height: 22px;

  :deep(svg) {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.social-icons_large .social-icons__link {
  width: 48px;
  height: 48px;
}

.social-icons_large .social-icons__icon {
  width: 28px;
  height: 28px;
}
</style>
